/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { createContext, HTMLAttributes, ReactElement, useContext } from 'react'
import { UseSelectionHook } from './useSelection'

export const SelectionContext = createContext<UseSelectionHook<any>>(null)

export function useSelectionContext<T> (): UseSelectionHook<T> {
  return useContext(SelectionContext)
}

export type SelectionProviderProps<T> = {
  context: UseSelectionHook<T>
}

function SelectionProvider<T> (
  props: SelectionProviderProps<T> & HTMLAttributes<HTMLElement>
): ReactElement {
  const { children, context } = props
  return (
    <SelectionContext.Provider value={context}>
      {children}
    </SelectionContext.Provider>
  )
}

export default SelectionProvider
